import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Text } from '@sravni/react-design-system/lib/Typography';

import { Question } from '@src/components/icons';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { CurrencySymbol } from 'shared/config/internalization';

import styles from './GooglePromoInfoBox.module.scss';

interface Props {
  bonusAmount: number;
  onOpenSheet: () => void;
}

export const GooglePromoInfoBox = ({ bonusAmount, onOpenSheet }: Props) => (
  <div className={styles.banner}>
    <Badge
      className={styles.badge}
      variant="primary"
      color="dark"
      text={
        <Text size={14} strong>
          {`${bonusAmount}${UNBREAKABLE_SEPARATOR}${CurrencySymbol.RUB}`}
        </Text>
      }
    />
    <Text className={styles.text} size={14}>
      бонус в приложении
    </Text>
    <Icon className={styles.icon} size={20} icon={<Question />} onClick={onOpenSheet} />
  </div>
);
